import { invoker, prop } from "ramda";
import { valueHandler } from "../csomjsom/csomJsomShared";

const getUrlValue = (value) => ({
    url: value?.get_url(),
    description: value?.get_description(),
});

const getLookupId = invoker(0, 'get_lookupId');

const getField = prop;

const jsomValueHandler = valueHandler(
    getField,
    getLookupId,
    getUrlValue,
);

export default jsomValueHandler;